import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
// import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/comprobanteEstadoType';
import auth from '../../../common/utility/auth';

const REGISTRADO = 1;
const EMITIDO = 2;
const RECHAZADO = 3;
const ANULADO = 4;

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idRetencionEstado === REGISTRADO)
            return 'blue';
        if (row.idRetencionEstado === EMITIDO)
            return 'green';
        if (row.idRetencionEstado === RECHAZADO)
            return 'orange';
        if (row.idRetencionEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idRetencionEstado === REGISTRADO ? true : false}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="CDR">
                                <Button
                                    type="primary"
                                    icon="file-text"
                                    size={"small"}
                                    disabled={row.idRetencionEstado !== REGISTRADO ? false : true}
                                    onClick={() => props.onCdr(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Enviar correo">
                                <Button
                                    type="primary"
                                    icon="mail"
                                    size={"small"}
                                    disabled={row.idRetencionEstado == EMITIDO ? false : true}
                                    onClick={() => props.onCorreo(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={row.idRetencionEstado === EMITIDO ? false : true}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>




                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idRetencionEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>



                            <Tooltip placement="top" title="Emitir">
                                <Button
                                    type="success"
                                    size={"small"}
                                    loading={props.loadingEmitir}
                                    style={{ paddingLeft: "4px", paddingRight: "4px" }}
                                    disabled={row.idRetencionEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onEmitir(row)}
                                >
                                    <img
                                        src={require(`../../../assets/images/send${row.idRetencionEstado === REGISTRADO ? "" : "-block"}.png`)}
                                        style={{ height: "14px", marginBottom: '3px' }} alt="icon" />
                                </Button>
                            </Tooltip>

                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Total Retencion',
                    dataIndex: 'totalRetencion',
                    key: 'totalRetencion',
                    align: 'right',
                    sorter: true,
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },

                {
                    title: 'Total',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreRetencionEstado',
                    key: 'nombreRetencionEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}